import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
  IconButton,
  Grid,
} from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';
import { TabletButton } from '@campfire/tablet-button';

interface ShareLocationDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (content: string, metadata: Record<string, unknown>) => void;
}

export const ShareLocationDialog = ({ open, onClose, onSubmit }: ShareLocationDialogProps) => {
  const [name, setName] = useState('');
  const [address, setAddress] = useState('');

  const handleSubmit = () => {
    if (!address.trim()) return;

    onSubmit(`Meeting point: ${name || address}`, {
      type: 'location_share',
      name: name.trim() || null,
      address: address.trim(),
    });
    handleClose();
  };

  const handleClose = () => {
    setName('');
    setAddress('');
    onClose();
  };

  if (!open) return null;

  return (
    <Dialog
      open
      onClose={handleClose}
      maxWidth='sm'
      fullWidth
      PaperProps={{ style: { borderRadius: 16, overflow: 'hidden' } }}
    >
      <DialogTitle style={{ paddingBottom: 0 }}>
        <Grid container justify='space-between' alignItems='flex-start'>
          <Grid item>
            <Typography style={{ fontWeight: 700, fontSize: '1.15rem', color: '#333' }}>Share Location</Typography>
            <Typography variant='body2' style={{ color: '#999', marginTop: 2 }}>
              Share a meeting point or address
            </Typography>
          </Grid>
          <Grid item>
            <IconButton aria-label='Close' size='small' onClick={handleClose} style={{ marginTop: -4 }}>
              <CloseIcon style={{ fontSize: 20, color: '#999' }} />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent style={{ paddingTop: 16, paddingBottom: 8 }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label='Location Name (optional)'
              variant='outlined'
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder='e.g. North Entrance'
              InputProps={{ style: { borderRadius: 10 } }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label='Address'
              variant='outlined'
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              required
              multiline
              maxRows={3}
              InputProps={{ style: { borderRadius: 10 } }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions style={{ padding: '8px 20px 16px' }}>
        <TabletButton variant='text' onClick={handleClose} style={{ marginRight: 8, color: '#999' }}>
          Cancel
        </TabletButton>
        <TabletButton variant='contained' color='primary' onClick={handleSubmit} disabled={!address.trim()}>
          Share Location
        </TabletButton>
      </DialogActions>
    </Dialog>
  );
};
